import { combineReducers } from 'redux';
import settings from './settings/reducer';
import menu from './menu/reducer';
import authUser from './auth/reducer';
import insuranceTypes from './insuranceType/reducer';
import formStructure from './forms/reducer';

const reducers = combineReducers({
  menu,
  settings,
  authUser,
  insuranceTypes,
  formStructure,
});

export default reducers;
